// 标签——主流程
const MainRoutes = Array.from({ length: 6 }, (_, i) => ({
  path: `module/label/index${i + 1}`,
  name: `module/labelIndex${i + 1}`,
  component: () => import(`@/views/recognize/module/label/index${i + 1}.vue`)
}))

export default {
  path: '/recognize',
  component: {
    render (c) {
      return c('router-view')
    }
  },
  children: [
    // 标签——主流程，开始
    ...MainRoutes
  ]
}
